import sal from 'sal.js'

export const salScrollAnimate = () => {

  sal();

}
